import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { resolveAppMountBase } from './lib/mountBase'
import { registerServiceWorker } from './lib/registerServiceWorker'
import { startConnectivityMonitor } from './lib/connectivity'
import './index.css'

// Start listening for connectivity changes before the first render, so the very
// first bootstrap request already knows whether the device has a network.
startConnectivityMonitor()

const routerBase = resolveAppMountBase(typeof window !== 'undefined' ? window.location.pathname : '/')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={routerBase || undefined}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)

// Retire the parser-painted boot shell (index.html) now that React owns the
// screen. Fades rather than cuts, so the handover to the in-app splash doesn't
// register as a flicker. requestAnimationFrame waits for the first committed
// frame — removing it synchronously here would expose a blank gap.
requestAnimationFrame(() => {
  const boot = document.getElementById('cc-boot')
  if (!boot) return
  boot.classList.add('cc-boot-done')
  setTimeout(() => boot.remove(), 250)
})

// Mounted builds register the SW inline before the <base> tag is injected
// (Chrome throws InvalidStateError if a <base> with a different href is present
// at register-time). The dashboard itself runs without a <base>, so register here.
if (!document.querySelector('base[data-cc-mount-base]')) {
  registerServiceWorker()
}
